module.exports = __webpack_public_path__ + "media/icons/menu-alt-4-bcf50f42.svg";